import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-auth-status',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section class="account" aria-label="Account">
      <div aria-live="polite">
        @if (auth.state() === 'authenticated') {
          <span>{{ auth.session()?.user?.displayName || auth.session()?.user?.email || 'Signed in' }}</span>
        } @else if (auth.state() === 'loading') {
          <span>Checking session...</span>
        } @else if (auth.state() === 'error') {
          <span>Account service unavailable.</span>
        }
      </div>
      @if (auth.state() === 'authenticated') {
        <button type="button" (click)="logout()" [disabled]="busy()">Sign out</button>
      } @else if (auth.state() === 'error') {
        <button type="button" (click)="retry()">Retry</button>
      } @else if (auth.state() === 'anonymous' || auth.state() === 'unknown') {
        <button type="button" (click)="auth.login('/')" [disabled]="auth.redirecting()">Login</button>
      }
      @if (message()) { <p role="alert">{{ message() }}</p> }
    </section>
  `,
  styles: `
    .account { display: flex; flex-wrap: wrap; align-items: center; justify-content: flex-end;
      gap: 12px; max-width: 1092px; margin: 0 auto; padding: 16px 24px;
      color: #172c32; font-family: 'Trebuchet MS', sans-serif; overflow-wrap: anywhere; }
    button { min-height: 40px; padding: 8px 18px; border: 1px solid #075c54; border-radius: 4px;
      background: #fff; color: #075c54; font: inherit; cursor: pointer; }
    button:disabled { opacity: .6; cursor: wait; }
    button:focus-visible { outline: 3px solid #075c54; outline-offset: 3px; }
    p { flex-basis: 100%; margin: 0; color: #9c2525; text-align: right; }
  `,
})
export class AuthStatusComponent implements OnInit {
  protected readonly auth = inject(AuthService);
  protected readonly busy = signal(false);
  protected readonly message = signal('');

  ngOnInit(): void { this.auth.initializeAfterLogin(); }

  protected retry(): void { void this.auth.initialize(true); }

  protected async logout(): Promise<void> {
    this.busy.set(true);
    this.message.set('');
    try {
      await this.auth.logout();
    } catch {
      this.message.set('Sign out could not be completed. Please retry.');
    } finally {
      this.busy.set(false);
    }
  }
}